// extracted by mini-css-extract-plugin
module.exports = {"layout":"WideImage_layout__2bEcj","image":"WideImage_image__3G1Ej","imageCol":"WideImage_imageCol__RqiGG","textCol":"WideImage_textCol__1v7L7","fadeIn":"WideImage_fadeIn__225MF"};